import { ChangeEvent, MouseEvent } from 'react';
import { Dispatch } from 'redux';

import { AppState } from '../reducers';
import { AgriActions } from './agri';
import { ApplicationActions } from './application';
import { CardsActions } from './cards';
import { CheckStatusActions } from './checkStatus';
import { CompleteOrderActions } from './completeOrder';
import { ConsentActions } from './consent';
import { LoadConfigActions } from './context';
import { FeatureToggleActions } from './feature';
import { FeedbackActions } from './feedback';
import { CaseActions } from './fetchCase';
import { KdkActions } from './kdk';
import { LBSActions } from './lbs';
import { NafActions } from './naf';
import { PinActions } from './pin';
import { SblActions } from './sbl';
import { SendApplicationActions } from './sendApplication';
import { SendOrderActions } from './sendOrder';
import { StepsActions } from './steps';
import { UrlParamsActions } from './urlParams';
import { UserActions } from './user';

export enum actionTypes {
    // Common
    CONTEXT_PATH = 'kredittbank-kredittkort-soknad-web',
    PUBLIC_PATH = 'kredittbank-kredittkort-soknad-web/dist',
    RESOURCE_PATH = '/kredittbank-kredittkort-soknad-web/rest/resource',
    LOAD_CONFIG = 'LOAD_CONFIG',
    OPEN_STEP = 'OPEN_STEP',
    PARAM_STATE_UPDATE = 'PARAM_STATE_UPDATE',

    FETCH_NAF_CACHE_STARTED = 'FETCH_NAF_CACHE_STARTED',
    FETCH_NAF_CACHE_FULFILLED = 'FETCH_NAF_CACHE_FULFILLED',
    FETCH_NAF_CACHE_FAILED = 'FETCH_NAF_CACHE_FAILED',
    FETCH_NAF_MEMBER_STARTED = 'FETCH_NAF_MEMBER_STARTED',
    FETCH_NAF_MEMBER_FULFILLED = 'FETCH_NAF_MEMBER_FULFILLED',
    FETCH_NAF_MEMBER_FAILED = 'FETCH_NAF_MEMBER_FAILED',
    FIELD_UPDATE_NAF_OPTION = 'FIELD_UPDATE_NAF_OPTION',
    FETCH_AGRI_MEMBER_STARTED = 'FETCH_AGRI_MEMBER_STARTED',
    FETCH_AGRI_MEMBER_FULFILLED = 'FETCH_AGRI_MEMBER_FULFILLED',
    FETCH_AGRI_MEMBER_FAILED = 'FETCH_AGRI_MEMBER_FAILED',
    FETCH_USER_SESSION_STARTED = 'FETCH_USER_SESSION_STARTED',
    FETCH_USER_SESSION_FULFILLED = 'FETCH_USER_SESSION_FULFILLED',
    FETCH_USER_SESSION_FAILED = 'FETCH_USER_SESSION_FAILED',
    FETCH_USER_CONTEXT_STARTED = 'FETCH_USER_CONTEXT_STARTED',
    FETCH_USER_CONTEXT_FULFILLED = 'FETCH_USER_CONTEXT_FULFILLED',
    FETCH_USER_CONTEXT_FAILED = 'FETCH_USER_CONTEXT_FAILED',
    FETCH_STATUS_STARTED = 'FETCH_STATUS_STARTED',
    FETCH_STATUS_FULFILLED = 'FETCH_STATUS_FULFILLED',
    FETCH_STATUS_FAILED = 'FETCH_STATUS_FAILED',
    FETCH_CASE_STARTED = 'FETCH_CASE_STARTED',
    FETCH_CASE_FULFILLED = 'FETCH_CASE_FULFILLED',
    FETCH_CASE_FAILED = 'FETCH_CASE_FAILED',
    FETCH_CARDS_STARTED = 'FETCH_CARDS_STARTED',
    FETCH_CARDS_FULFILLED = 'FETCH_CARDS_FULFILLED',
    FETCH_CARDS_FAILED = 'FETCH_CARDS_FAILED',
    CHANGE_SOKNAD_FIELD = 'CHANGE_SOKNAD_FIELD',
    VERIFY_SOKNAD_FIELD = 'VERIFY_SOKNAD_FIELD',
    VALIDATE_STATUS_FULFILLED = 'VALIDATE_STATUS_FULFILLED',
    VERIFY_CONTACT_INFO = 'VERIFY_CONTACT_INFO',
    VERIFY_SOKNAD_SKJEMA = 'VERIFY_SOKNAD_SKJEMA',
    VERIFY_BESTILLING_SKJEMA = 'VERIFY_BESTILLING_SKJEMA',
    SET_KYC_COMPLETED = 'SET_KYC_COMPLETED',
    FIELD_UPDATE_CREDIT = 'FIELD_UPDATE_CREDIT',
    FORM_UPDATE_ABOUT = 'FORM_UPDATE_ABOUT',
    FORM_UPDATE_CONTACT = 'FORM_UPDATE_CONTACT',

    // Send Application
    SEND_APPLICATION_STARTED = 'SEND_APPLICATION_STARTED',
    SEND_APPLICATION_FULFILLED = 'SEND_APPLICATION_FULFILLED',
    SEND_APPLICATION_FAILED = 'SEND_APPLICATION_FAILED',

    // Fetch Consent
    FETCH_CONSENT_STARTED = 'FETCH_CONSENT_STARTED',
    FETCH_CONSENT_FULFILLED = 'FETCH_CONSENT_FULFILLED',
    FETCH_CONSENT_FAILED = 'FETCH_CONSENT_FAILED',

    // Save Consent
    UPDATE_CONSENT = 'UPDATE_CONSENT',
    SAVE_CONSENT_STARTED = 'SAVE_CONSENT_STARTED',
    SAVE_CONSENT_FULFILLED = 'SAVE_CONSENT_FULFILLED',
    SAVE_CONSENT_FAILED = 'SAVE_CONSENT_FAILED',

    // Send Order
    SEND_ORDER_STARTED = 'SEND_ORDER_STARTED',
    SEND_ORDER_FULFILLED = 'SEND_ORDER_FULFILLED',
    SEND_ORDER_FAILED = 'SEND_ORDER_FAILED',

    // Send Feedback
    SEND_FEEDBACK_STARTED = 'SEND_FEEDBACK_STARTED',
    SEND_FEEDBACK_FULFILLED = 'SEND_FEEDBACK_FULFILLED',
    SEND_FEEDBACK_FAILED = 'SEND_FEEDBACK_FAILED',

    // Set PIN
    SET_PIN_STARTED = 'SET_PIN_STARTED',
    SET_PIN_FULFILLED = 'SET_PIN_FULFILLED',
    SET_PIN_FAILED = 'SET_PIN_FAILED',

    // Complete Order
    COMPLETE_ORDER_STARTED = 'COMPLETE_ORDER_STARTED',
    COMPLETE_ORDER_FULFILLED = 'COMPLETE_ORDER_FULFILLED',
    COMPLETE_ORDER_FAILED = 'COMPLETE_ORDER_FAILED',

    // SBL consent
    CREATE_SBL_CONSENT_STARTED = 'CREATE_SBL_CONSENT_STARTED',
    CREATE_SBL_CONSENT_FULFILLED = 'CREATE_SBL_CONSENT_FULFILLED',
    CREATE_SBL_CONSENT_FAILED = 'CREATE_SBL_CONSENT_FAILED',

    FETCH_SBL_CONSENT_STARTED = 'FETCH_SBL_CONSENT_STARTED',
    FETCH_SBL_CONSENT_FULFILLED = 'FETCH_SBL_CONSENT_FULFILLED',
    FETCH_SBL_CONSENT_FAILED = 'FETCH_SBL_CONSENT_FAILED',

    // Feature Toggle
    FEATURE_TOGGLE_STARTED = 'FEATURE_TOGGLE_STARTED',
    FEATURE_TOGGLE_FULFILLED = 'FEATURE_TOGGLE_FULFILLED',
    FEATURE_TOGGLE_FAILED = 'FEATURE_TOGGLE_FAILED',

    // Other
    CHANGE_LBS_BANK = 'CHANGE_LBS_BANK',
    SHOW_LBS_SELECT = 'SHOW_LBS_SELECT',
    FETCH_TEST_USER_TOGGLE_FULFILLED = 'FETCH_TEST_USER_TOGGLE_FULFILLED',
    KYC_ERROR = 'KYC_ERROR',
    SHOW_DIALOG = 'SHOW_DIALOG',
}

/* Redux Action */
type ReduxAction = import('redux').Action;

// @ts-ignore
export interface Action<T> extends ReduxAction {
    type: T;
}

/* Typed Actions */
export type AppActions =
    | AgriActions
    | ApplicationActions
    | CardsActions
    | CheckStatusActions
    | CompleteOrderActions
    | ConsentActions
    | KdkActions
    | LoadConfigActions
    | NafActions
    | PinActions
    | SendApplicationActions
    | SendOrderActions
    | StepsActions
    | UrlParamsActions
    | UserActions
    | LBSActions
    | FeedbackActions
    | SblActions
    | FeatureToggleActions
    | CaseActions;

/* Dispatching */
export type DispatchWithState = (dispatch: Dispatch<AppActions>, getState: () => AppState) => void;

/* Action Events */
export type InputChangeEvent = ChangeEvent<HTMLInputElement>;
export type ButtonClickEvent = MouseEvent<HTMLButtonElement>;
export type ButtonGroupChangeEvent = (e: { name: string; value: string | number }) => void;
export type NameValueStringEvent = (name: string, value: string) => void;

/* Common Types */
export interface StringKeyValue {
    [k: string]: string;
}

export interface StringKeyAnyValue {
    [k: string]: any;
}

export interface NameValueString {
    name: string;
    value: string;
}
